import OrbitAvatar from '@/components/OrbitAvatar'
import { Organization } from '@/services/organization/organization.model'
import { getOrganizationById, getUserOrgAccount } from '@/services/organization/organization.service'
import { useRequest } from 'ahooks'
import { Col, Row, Tabs, Typography } from 'antd'
import classnames from 'classnames'
import React, { memo, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { Outlet, useMatch, useParams } from 'react-router-dom'
import styles from './index.module.less'
import { ACCOUNT_TYPES } from '@/utils/constants'
const { TabPane } = Tabs

interface OrganizationContextProps {
  orgData: Organization.Info | null
  orgRefresh: () => void
}

export const OrganizationContext = React.createContext<OrganizationContextProps>({
  orgData: null,
  orgRefresh: () => {}
})

export default memo(function OrganizationItem() {
  const navigate = useNavigate()
  const { orgId } = useParams()
  const match = useMatch('/:orgId/:key/*')
  const activeKey = useMemo(() => match?.params.key || '', [match])
  const { data: orgData, refresh: orgRefresh } = useRequest(() => getOrganizationById(Number(orgId)))
  const {data: userAccount} = useRequest(() => getUserOrgAccount(Number(orgId)))

  const tabOnChange = (activeKey: string) => {
    navigate(activeKey)
  }

  const tabs = useMemo(() => {
    const baseTabs = [
      { text: 'Projects', key: 'projects' },
    ]
    const adminTypes = [ACCOUNT_TYPES.ADMINISTRATOR, ACCOUNT_TYPES.OWNER]
    if (adminTypes.includes((userAccount?.accountType || '').toLowerCase())) {
      baseTabs.push(
        { text: 'Physical Properties', key: 'physical-properties' },
        { text: 'Equipment', key: 'equipment' },
        { text: 'Members', key: 'members' },
        { text: 'Setting', key: 'setting' }
      )
    }
    return baseTabs;
  }, [userAccount])

  if (!orgData) {
    return null
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={'container-xl px-3'}>
          <Row align={'middle'} gutter={16}>
            <Col>
              <OrbitAvatar size={72} avatar={orgData.avatar} name={orgData.name} />
            </Col>
            <Col>
              <Typography.Title level={4} className={'mb-1'}>
                {orgData.name}
              </Typography.Title>
              <Typography.Text>{orgData.contactEmail}</Typography.Text> <br />
              <Typography.Text>{orgData.description}</Typography.Text>
            </Col>
          </Row>
          <Tabs activeKey={activeKey} onChange={tabOnChange}>
            {tabs.map((item) => (
              <TabPane tab={item.text} key={item.key} />
            ))}
          </Tabs>
        </div>
      </header>

      <div className={styles.content}>
        <div className={classnames('container-xl px-3')}>
          <div className={styles.contentChildren}>
            <OrganizationContext.Provider value={{ orgData: orgData, orgRefresh }}>
              <Outlet />
            </OrganizationContext.Provider>
          </div>
        </div>
      </div>
    </div>
  )
})
